import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import { collectiveKeys } from "./queryKeys";
import type { Collective, CollectiveFormFields } from "../types";

/**
 * Create new Collective
 */
const createCollective = ({ id, ...collective }: CollectiveFormFields) =>
  api.post<Collective>("/collective/create", {
    body: JSON.stringify({ id, collective }),
  });

/**
 * Custom hook to create new Collective and manage state
 */
const useCreateCollective = () => {
  const queryClient = useQueryClient();

  return useMutation(createCollective, {
    onSuccess: (updates) => {
      // Update cache with new data
      queryClient.setQueryData(collectiveKeys.detail(updates.id), updates);
      // Invalidate all Collective list queries
      queryClient.invalidateQueries(collectiveKeys.lists());
    },
  });
};

export { useCreateCollective };
